import styled from 'styled-components';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import {
  FONT_STACK,
  FontSize,
  FontWeight,
  ZIndex,
  Breakpoint,
} from '../../../common/styles/constants';

const TEAL_SLANTED_PILL =
  'https://healthengine.imgix.net/public/images/teal-slanted-pill-section_20210628071146.svg?auto=compress&ixlib=php-3.3.0&or=0';

export const Table = styled.table`
  margin-bottom: 24px;
  margin-top: 16px;
  text-align: left;
  width: 100%;

  tr {
    vertical-align: baseline;
  }

  tr,
  td:not(:last) {
    padding-right: 10px;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  background-color: ${ThemeColours.primary700};
  background-image: url(${TEAL_SLANTED_PILL});
  background-repeat: no-repeat;
  background-size: initial;
  display: flex;
  flex-direction: column;
  padding: 40px 0px;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: ${ZIndex.NORMAL};

  ${Breakpoint.SMALL} {
    background-size: 200% 1000px;
  }

  ${Breakpoint.LARGE} {
    background-size: 100vw 600px;
    padding: 96px 0px 40px 0px;
  }

  & * {
    z-index: ${ZIndex.OVERLAY};
  }
`;

export const Title = styled.h3`
  ${FONT_STACK};
  color: ${ThemeColours.white};
  font-size: ${FontSize.LARGE}
  font-weight: ${FontWeight.REGULAR};
  margin: 0 20px 50px 20px;
  text-align: center;
  
  ${Breakpoint.LARGE} {
    font-size: ${FontSize.HEADING_3}
  }
`;
